import { Store, ActionContext } from 'vuex'

import { State } from './state'
import { RootState } from '~/store/state'

import cancelPreviousRequestAndGetNewCancelToken from '@/utils/functions/cancelPreviousRequestAndGetNewCancelToken/forStore'

import {
  handleAxiosErrorServerFromStoreV3,
  handleAxiosErrorFrontendFromStoreV3
} from '@/utils/functions/handle-errors'

export async function fetchBrandsForIds(
  this: Store<RootState>,
  { state, commit }: ActionContext<State, RootState>,
  ids: number[]
) {
  commit('addIdsBeingFetched', ids)

  commit('setLoadingState', true)
  commit('resetError')

  const cancelToken = cancelPreviousRequestAndGetNewCancelToken({
    state,
    commit
  })

  let response
  try {
    response = await this.$axios.get('/brands/from_ids', {
      params: { ids: state.idsBeingFetched },
      cancelToken
    })
  } catch (error) {
    if (this.$axios.isCancel(error)) return

    handleAxiosErrorServerFromStoreV3({
      error,
      commit,
      store: this,
      mutationNameForLoadingState: 'setLoadingState',
      mutationNameForSettingError: 'setError'
    })
    return
  }

  if (!response.data.success) {
    handleAxiosErrorFrontendFromStoreV3({
      response,
      commit,
      store: this,
      mutationNameForLoadingState: 'setLoadingState',
      mutationNameForSettingError: 'setError'
    })
    return
  }

  commit('resetIdsBeingFetched')
  commit('addBrandsById', response.data.result.brands_by_id)
  commit('setLoadingState', false)
  commit('setLoadedState', true)
}
